<p>{{ data.text }}</p>

<div class="actions">
  <a mat-button mat-dialog-close>取消</a>
  <a mat-button (click)="confirm()">确认</a>
</div>
